import env from '@shared/api/env';

// Support both legacy and new server shapes
export type PaletteItem =
  | {
      key: string;
      title: string;
      category: string;
      icon?: string;
      ports?: {
        data?: {
          in?: Array<{ id: string; schema?: unknown }>;
          out?: Array<{ id: string; schema?: unknown }>;
        };
      };
      attrsSchema?: unknown;
      /** Optional per-attribute UI hints provided by backend. */
      attrsUi?: Record<string, unknown>;
      /** Optional form-level UI hints (tabs/sections) provided by backend. */
      formUi?: Record<string, unknown>;
    }
  | {
      handler: string;
      /** Optional node type identifier provided by backend (e.g., "parallel") */
      type?: string;
      version?: string;
      title: string;
      description?: string;
      category: string;
      icon?: string;
      pins?: { in?: string[]; out?: string[] };
      input?: any;
      output?: any;
      attrs?: any;
      /** Optional per-attribute UI hints provided by backend. */
      attrsUi?: Record<string, unknown>;
      /** Optional form-level UI hints (tabs/sections) provided by backend. */
      formUi?: Record<string, unknown>;
    };

const CACHE_KEY = 'palette.cache.v1';

export async function fetchPalette(): Promise<{ items: PaletteItem[] }> {
  // Be resilient if env vars are missing; prefer CONDUIT_BASE, fall back to BLAST_API.
  const rawBase = (env as any)?.CONDUIT_BASE ?? (env as any)?.BLAST_API ?? '';
  const base = typeof rawBase === 'string' ? rawBase : '';
  const url = base ? `${String(base).replace(/\/$/, '')}/handlers/palette` : '';
  try {
    if (url) {
      const res = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const json = await res.json();
      try { localStorage.setItem(CACHE_KEY, JSON.stringify(json)); } catch {}
      return json;
    }
    // No remote URL available: try cache before failing.
    throw new Error('Missing CONDUIT_BASE/BLAST_API; skipping remote palette fetch');
  } catch (e) {
    const cached = localStorage.getItem(CACHE_KEY);
    if (cached) {
      return JSON.parse(cached);
    }
    // Rethrow with context so callers see a clear reason when no cache exists.
    throw new Error(
      `Palette fetch failed: ${
        e instanceof Error ? e.message : String(e)
      } (and no cached palette was available)`
    );
  }
}
